import {
  Bg,
  TitleBox,
  BtnSearch,
  Container,
  WrapperCard,
  ConainerMain,
  WrapperContent,
} from './styles';
import React from 'react';
import { TitleSection } from '../AreaVariation/styles';
import { LupaSearch } from '../IndicatorSynthesis/styles';
import { useIndicators, useNavigator, useRanking } from '@/hooks';
import { VariationCard } from '../../molecules/AreaVariation/Card';
import { VariationCardThree } from '../../molecules/AreaVariationBest/Card';

export interface Variacoes {
  complete_name: string,
  code: string,
  decada: {
    ano_inicial: number,
    ano_final: number,
    melhor: {
      UF: any,
      valor: number
    },
    pior: {
      UF: any,
      valor: number
    }
  },
  ano: {
    ano_inicial: number,
    ano_final: number,
    melhor: {
      UF: any,
      valor: 5
    },
    pior: {
      UF: any,
      valor: number
    }
  },
  melhor: {
    UF: any,
    valor: number
  },
  pior: {
    UF: any,
    valor: number
  },
  media_br: number,
  text: string,
  destaque: string,
  info: string,
  indicators_icon: any;
}

interface SectionCardLayerProps {
  header?: boolean;
  data: Variacoes;
  index: number;
}

const SectionCardLayer: React.FC<SectionCardLayerProps> = ({ header = true, data, index }) => {
  const { handleChangePathname } = useNavigator();
  const { RakingData, researchArea } = useRanking();
  const { handleCommitedIndicator } = useIndicators();

  const handleClick = (indicador: string) => {
    handleCommitedIndicator(indicador);
    handleChangePathname('/indicadores');
  };

  return (
    <>
      <Container>
        <WrapperContent>
          {header && (
            <TitleBox>
              <div className='wrapper'>
                <Bg color={RakingData[researchArea]?.config?.color}>
                  {data?.indicators_icon !== undefined && (data?.indicators_icon[index])}
                </Bg>
                <div dangerouslySetInnerHTML={{ __html: `<p>${data?.complete_name as unknown as string}</p>` }} >
                </div>

              </div>
              <BtnSearch onClick={() => handleClick(data?.code)} color={RakingData[researchArea]?.config?.color} >
                <LupaSearch />
                <p>Ver visão do indicador</p>
              </BtnSearch>
            </TitleBox>
          )}
          <WrapperCard>
            {/* <VariationCard name="posicao" data={RakingData[researchArea]?.destaques?.posicao} /> */}
            <VariationCard name="posicao" data={data as any} />
            <VariationCardThree data={data} />
          </WrapperCard>
        </WrapperContent>
      </Container>
    </>
  );
};


export const AreaVariationBest: React.FC = () => {
  const { indicatorsData } = useIndicators();

  if (indicatorsData !== undefined) {
    return (
      <ConainerMain>
        <div className='teste'>
          {indicatorsData[0] !== undefined &&
            <TitleSection>Destaques positivos e negativos dos indicadores</TitleSection>
          }
        </div>
        {indicatorsData?.map((data: Variacoes, index: number) => (
          <SectionCardLayer
            key={data.code}
            data={data}
            index={index}
          />
        ))}
      </ConainerMain>
    );
  }

  return <ConainerMain />;
};
